<form data-cy="context-new__form-form" #form="ngForm" (ngSubmit)="submit()">
    <div data-cy="context-new__page" mat-dialog-title>
        <h4 class="mb-10 inline-block">
            {{ "new" | transloco | capitaliz }}
            context item
        </h4>
        <button data-cy="context-new__close-btn" type="button" class="close modal-close-button" (click)="close()">
            <span aria-hidden="true"><i class="d-text-middle uil uil-multiply unicon-icon"></i></span>
            <span class="sr-only">Close</span>
        </button>   
    </div>

    <!-- modal body -->
    <mat-dialog-content data-cy="context-new__dialog-content">
        <div class="col-xs-12 col-md-6">
            <mat-form-field class="full-width">
                <mat-label>{{'name' | transloco | capitaliz}}</mat-label>
                <input data-cy="context-new__text-input" matInput type="text" name="text" [(ngModel)]="entity.text" required/>
            </mat-form-field>
            <div>
                <!-- <app-generic-multiselect-checkbox [placeholder]="'type' | transloco | capitaliz" name="cnotextType"
                    [(ngModel)]="entity.types" ngDefaultControl [uniqueId]="'context-themes'" [required]="true">
                    <app-generic-multiselect-checkbox-option *ngFor="let type of types" [value]="type">
                        {{ 'contexts.context_type.'+type.name | transloco | capitaliz }}
                    </app-generic-multiselect-checkbox-option>
                </app-generic-multiselect-checkbox> -->

                <app-generic-uniselect [placeholder]="'type' | transloco | capitaliz" [selectedValue]="entity.types" (onThemeSelected)="onSelectTheme($event)" [items]="types" [required]="true" [uniqueId]="'context-type'"></app-generic-uniselect>
            </div>
            <div>
                <mat-form-field class="full-width">
                    <mat-label>{{ 'reusable.description' | transloco }}</mat-label>
                    <textarea data-cy="context-new__description-input" matInput name="description" [(ngModel)]="entity.description" rows="3" required></textarea>
                </mat-form-field>
            </div>
            <div>
                <label class="text-capitalize">{{'stakeholders' | transloco | capitaliz}}</label>
                <app-generic-multiselect-checkbox data-cy="context-new__generic-multiselect-checkbox" [placeholder]="'reusable.select_involve_stakeholder' | transloco" name="stakeholders"
                    [(ngModel)]="entity.stakeholders" ngDefaultControl [uniqueId]="'context-stakeholders'">
                    <app-generic-multiselect-checkbox-option *ngFor="let stk of stakeholders" [value]="stk">
                        {{ stk.name }}
                    </app-generic-multiselect-checkbox-option>
                </app-generic-multiselect-checkbox>
            </div>
            <div>
                <label class="text-capitalize">Issues</label>
                <app-generic-multiselect-checkbox data-cy="context-new__generic-multiselect-checkbox-2" [placeholder]="'reusable.select_involve_issue'|transloco" name="issues"
                    [(ngModel)]="entity.issues" ngDefaultControl [uniqueId]="'context-issues'">
                    <app-generic-multiselect-checkbox-option *ngFor="let issue of issues" [value]="issue">
                        {{ issue.name }}
                    </app-generic-multiselect-checkbox-option>
                </app-generic-multiselect-checkbox>
            </div>
        </div>

        <div class="col-xs-12 col-md-6">
            <div>
                <label class="text-capitalize">{{ "location" | transloco }}</label>
                <div class="map-container">
                    <app-openlayers-map data-cy="context-new__openlayers-map" type="context" [selectedContextType]="entity.types" [disabled]="!entity.types.length" [(ngModel)]="entity.locations" ngDefaultControl [includeSidebar]="true" [collapseSidebar]="true" [defaultCoordinate]="globals.projectConfig.default_map" [showMapReset]="true" name="locations" locatableType="context" [sidebarButtons]="['length', 'point', 'area']" defaultDrawTool="area"></app-openlayers-map>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions data-cy="context-new__dialog-actions" align="end">
        <div class="dialog-button-row">
            <button data-cy="context-new__close-btn-2" type="button" mat-stroked-button data-dismiss="modal" [disabled]="isProcessing" (click)="close()">
                {{ "cancel" | transloco | capitaliz }}
            </button>
            <button data-cy="context-new__submit-btn" type="submit" mat-flat-button [disabled]="!entity.description || !entity.types.length || !entity.text">
                <span *ngIf="!isProcessing">
                    <mat-icon class="material-icons d-text-middle">save</mat-icon>
                    {{ "add" | transloco | capitaliz }}
                </span>
                <span *ngIf="isProcessing">
                    {{ "text.please_wait" | transloco | capitaliz }}</span>
            </button>
        </div>
        <!--end of modal footer -->
    </mat-dialog-actions>
</form>